import { Brand } from '../../shared/models/brand';

export class Context {
  brand: Brand;
  coBrandLogo: string;
  brokerLogo: string;
  brokerWebsiteUrl?: string;
  isBrandClickable?: boolean;
  partnerUrlFr?: string;
  partnerUrlNl?: string;
}

export enum PartnerCode {
  YOLPartner = 38839,
  UppiePartner = 28063,
}

export const ProcessCd = {
  DirectLogin: 'TCPRCS.000',
  SubscriptionFlow: 'TCPRCS.C04',
  BrokerFlow: 'TCPRCS.S04'
}

export const APIFailure = {
  GetValidationParametersAPI: 'getvalidationparameters',
  RetrievePersonDetailsAPI: 'retrievepersondetails',
  UserLogin : 'loginuser',
  IsSubscriptionAllowedAPI: 'issubscriptionallowed',
  CreateUserAPI: 'createuser',
  PersonalDetailsResolverAPI: 'getpersondetails',
  GetTermsOfUseConsent: 'gettermsofuseconsent',
  isContactAndTOUAvailable: 'isContactAndTOUAvailable',
  ValidatePerson: 'validateperson'
}

export const SurveyFlow = {
  CreateQuote: 'createQuote',
  Survey: 'survey'
}
